import { Button } from 'antd';
import styled from 'styled-components';

import { MpPropertyTitle } from 'shared/ui/MpPropertyTitle';

export const ContainerStyled = styled.div`
	padding: 16px;
	width: 100%;
	border: 1px solid #d9d9d9;
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		padding: 24px;
	}
`;

export const HeadingContainerStyled = styled.div`
	display: flex;
	justify-content: space-between;
	padding-bottom: 12px;
`;

export const InfoContainerStyled = styled.div`
	row-gap: 24px;
	display: flex;
	padding-top: 12px;

	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		display: grid;
		grid-template-columns: 1fr 1fr;
		column-gap: 40px;
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		display: flex;
		column-gap: 60px;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		column-gap: 35px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		column-gap: 60px;
	}
`;

export const InfoItemStyled = styled.div`
	width: fit-content;
`;

export const InfoHeadingStyled = styled.h5`
	color: #8c8c8c;
	font-weight: 400;
	font-size: 12px;
	line-height: 20px;
`;

export const InvoiceHeadingContainerStyled = styled.div`
	gap: 12px;
	display: flex;
	align-items: center;
`;

export const InvoiceHeading = styled(MpPropertyTitle)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 0;
	width: 100%;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: block;
	}
`;

export const ButtonStyled = styled(Button)`
	display: none;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: block;
	}
`;

export const ButtonMStyled = styled(Button)`
	display: block;
	margin-top: 24px;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: none;
	}
`;
